import { render } from "./FormProducts.vue?vue&type=template&id=6cd28bfe&scoped=true"
import script from "./FormProducts.vue?vue&type=script&lang=js"
export * from "./FormProducts.vue?vue&type=script&lang=js"

import "./FormProducts.vue?vue&type=style&index=0&id=6cd28bfe&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd28bfe"]])

export default __exports__